import AddTaskIcon from '@mui/icons-material/AddTask';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ComputerIcon from '@mui/icons-material/Computer';
import EmailIcon from '@mui/icons-material/Email';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import MarkChatUnreadIcon from '@mui/icons-material/MarkChatUnread';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ModeCommentIcon from '@mui/icons-material/ModeComment';
import PortraitIcon from '@mui/icons-material/Portrait';
import SendIcon from '@mui/icons-material/Send';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import palette from '/b2b/common/theme/palette';

export const DSAR_EVENTS = {
    ACTION_ITEMS_ASSIGNED: 'dsar.actionItemAssigned',
    ACTION_ITEMS_CREATED: 'dsar.actionItemsCreated',
    ACTION_ITEM_COMPLETED: 'dsar.actionItemCompleted',
    ACTION_ITEM_CREATED: 'dsar.actionItemCreated',
    DSAR_COMPLETED: 'dsar.completed',
    DSAR_COMPLETED_EMAIL_SENT: 'dsar.completedEmailSent',
    DSAR_CREATED_EMAIL_SENT: 'dsar.requestCreatedEmailSent',
    DSAR_EMAIL_VERIFIED: 'dsar.emailVerified',
    DSAR_EMAIL_INQUIRY_RECEIVED: 'dsar.intakeEmailReceived',
    DSAR_EMAIL_INQUIRY_RESPONSE: 'dsar.intakeEmailReplied',
    DSAR_IDENTITY_VERIFIED: 'dsar.identityVerified',
    DSAR_IN_PROGRESS: 'dsar.inProgress',
    DSAR_PENDING_IDENTITY_VERIFICATION: 'dsar.pendingIdentityVerification',
    DSAR_READY_FOR_REVIEW: 'dsar.readyForReview',
    DSAR_REJECTED: 'dsar.rejected',
    DSAR_REJECTED_EMAIL_SENT: 'dsar.rejectedEmailSent',
    DSAR_REQUEST_CREATED: 'dsar.requestCreated',
    DSAR_VERIFICATION_REMINDER_EMAIL_SENT: 'dsar.verificationReminderEmailSent',
    DSAR_VERIFIED_EMAIL_SENT: 'dsar.verifiedEmailSent',
    USER_PORTAL_MESSAGE_RECEIVED: 'dsar.portalMessageReceived',
    USER_PORTAL_MESSAGE_SENT: 'dsar.b2bPortalMessageSent',
    USER_PORTAL_MESSAGE_SENT_EMAIL_SENT: 'dsar.b2bPortalMessageSentEmailSent',
};

export const EVENTS = {
    [DSAR_EVENTS.ACTION_ITEMS_ASSIGNED]: {
        color: palette.info.light,
        icon: ArrowRightAltIcon,
    },
    [DSAR_EVENTS.ACTION_ITEMS_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_COMPLETED]: {
        color: palette.success.light,
        icon: CheckIcon,
    },
    [DSAR_EVENTS.ACTION_ITEM_CREATED]: {
        color: palette.info.light,
        icon: AddTaskIcon,
    },
    [DSAR_EVENTS.DSAR_COMPLETED]: {
        color: palette.success.main,
        icon: CelebrationIcon,
    },
    [DSAR_EVENTS.DSAR_COMPLETED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_CREATED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_VERIFIED]: {
        color: palette.success.main,
        icon: MarkEmailReadIcon,
    },
    [DSAR_EVENTS.DSAR_IN_PROGRESS]: {
        color: palette.common.magenta,
        icon: TimelapseIcon,
    },
    [DSAR_EVENTS.DSAR_PENDING_IDENTITY_VERIFICATION]: {
        color: palette.warning.light,
        icon: PortraitIcon,
    },
    [DSAR_EVENTS.DSAR_IDENTITY_VERIFIED]: {
        color: palette.success.main,
        icon: InsertEmoticonIcon,
    },
    [DSAR_EVENTS.DSAR_READY_FOR_REVIEW]: {
        color: palette.secondaryLight.light,
        icon: AssignmentIcon,
    },
    [DSAR_EVENTS.DSAR_REJECTED]: {
        color: palette.error.main,
        icon: CloseIcon,
    },
    [DSAR_EVENTS.DSAR_REJECTED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_REQUEST_CREATED]: {
        color: palette.warning.light,
        icon: ComputerIcon,
    },
    [DSAR_EVENTS.DSAR_VERIFICATION_REMINDER_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_VERIFIED_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_RECEIVED]: {
        color: palette.info.light,
        icon: MarkChatUnreadIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_SENT]: {
        color: palette.primary.light,
        icon: ModeCommentIcon,
    },
    [DSAR_EVENTS.USER_PORTAL_MESSAGE_SENT_EMAIL_SENT]: {
        color: palette.data6.main,
        icon: SendIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_INQUIRY_RECEIVED]: {
        color: palette.info.light,
        icon: EmailIcon,
    },
    [DSAR_EVENTS.DSAR_EMAIL_INQUIRY_RESPONSE]: {
        color: palette.info.light,
        icon: SendIcon,
    },
};

export const RESOURCE_TYPES = {
    DSAR: 'DSAR',
};

export const RESOURCE_TYPE_PATHS = {
    [RESOURCE_TYPES.DSAR]: '/subject-rights/requests/:resourceId',
};

export const AUDIT_USER_REPLACEMENTS = {
    API_USER: 'common.apiUser',
    AUTOMATION: 'common.automation',
};
